/* eslint-disable no-continue */
/* eslint-disable camelcase */

import * as XLSX from "xlsx-js-style"

export const createXlsx = (sheets, conjunto) => {
  /* 
    1.- Datos de la tabla
    2.- Array de columnas tipo modena
    3.- Nombre de cada hoja
    4.- Nombre del xlsx
  */
  const wb = XLSX.utils.book_new()

  for (let hojas = 0; hojas < sheets.length; hojas++) {
    if (sheets[hojas]?.table.length > 0) {
      // Diseño encabezado
      const headers = Object.keys(sheets[hojas]?.table[0])
      const aoaData = [headers].concat(
        sheets[hojas]?.table.map(item => headers.map(header => item[header]))
      )

      const Titulos = [[conjunto.Nombre], [sheets[0].name], []]
      const headerCustom = Titulos.concat(aoaData)
      const ws = XLSX.utils.aoa_to_sheet(headerCustom)

      // Header de todos los reporets
      const mergeConjunto = {
        s: { r: 0, c: 0 },
        e: { r: 0, c: headers.length - 1 },
      }
      const mergeReporte = {
        s: { r: 1, c: 0 },
        e: { r: 1, c: headers.length - 1 },
      }
      if (!ws["!merges"]) ws["!merges"] = []
      ws["!merges"].push(mergeConjunto)
      ws["!merges"].push(mergeReporte)

      for (let i = 0; i < 2; i++) {
        const cell_address1 = XLSX.utils.encode_cell({ c: 0, r: i })
        ws[cell_address1].s = {
          fill: {
            fgColor: { rgb: "092147" }, // Fondo azul
          },
          font: {
            color: { rgb: "FFFFFFFF" }, // Texto blanco
            bold: true,
          },
          alignment: {
            horizontal: "center",
          },
        }
      }
      // Aplicar estilo al encabezado
      for (let col = 0; col < headers.length; col++) {
        const cell_address = XLSX.utils.encode_cell({ c: col, r: 3 })
        ws[cell_address].s = {
          fill: {
            fgColor: { rgb: "092147" }, // Fondo azul
          },
          font: {
            color: { rgb: "FFFFFFFF" }, // Texto blanco
            bold: true,
          },
          border: {
            top: { style: "thin", color: { auto: 1 } },
            bottom: { style: "thin", color: { auto: 1 } },
            left: { style: "thin", color: { auto: 1 } },
            right: { style: "thin", color: { auto: 1 } },
          },
          alignment: {
            horizontal: "center",
          },
        }
      }

      const rowStylePredicate = sheets[hojas]?.rowStylePredicate
      const rowStyle = sheets[hojas]?.rowStyle
      if (rowStylePredicate && rowStyle) {
        for (let i = 0; i < sheets[hojas].table.length; i++) {
          if (!rowStylePredicate(sheets[hojas].table[i], i)) continue
          const rowIndex = i + 4
          for (let col = 0; col < headers.length; col++) {
            const cell_address = XLSX.utils.encode_cell({ c: col, r: rowIndex })
            if (!ws[cell_address]) continue
            ws[cell_address].s = rowStyle
          }
        }
      }

      // columas tipo moneda
      const columnasMoneda = []
      for (let i = 0; i < sheets[hojas]?.columns?.length; i++) {
        columnasMoneda.push(XLSX.utils.decode_col(sheets[hojas]?.columns[i]))
      }
      for (let i = 1; i <= sheets[hojas].table.length + 3; i++) {
        for (let j = 0; j < columnasMoneda.length; j++) {
          const cell_address_moneda_G = { c: columnasMoneda[j], r: i }
          const cell_ref_moneda_G = XLSX.utils.encode_cell(
            cell_address_moneda_G
          )
          if (!ws[cell_ref_moneda_G]) continue
          ws[cell_ref_moneda_G].z = "$#,##0.00"
        }
      }

      const columnasDecimales = []
      for (let i = 0; i < sheets[hojas]?.decimalColumns?.length; i++) {
        columnasDecimales.push(
          XLSX.utils.decode_col(sheets[hojas]?.decimalColumns[i])
        )
      }
      for (let i = 1; i <= sheets[hojas].table.length + 3; i++) {
        for (let j = 0; j < columnasDecimales.length; j++) {
          const cellAddress = { c: columnasDecimales[j], r: i }
          const cellRef = XLSX.utils.encode_cell(cellAddress)
          if (!ws[cellRef]) continue
          ws[cellRef].z = "0.00"
        }
      }
      autoSizeColumn(ws)

      XLSX.utils.book_append_sheet(wb, ws, sheets[hojas]?.sheet)
    }
  }
  XLSX.writeFile(wb, `${conjunto.Nombre} ${sheets[0]?.name}.xlsx`)
}

export function autoSizeColumn(sheet) {
  const cols = []
  const range = XLSX.utils.decode_range(sheet["!ref"])
  for (let C = range.s.c; C <= range.e.c; ++C) {
    let max_length = 0
    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cell_ref = XLSX.utils.encode_cell({ c: C, r: R })
      if (sheet[cell_ref] && sheet[cell_ref].v) {
        max_length = Math.max(max_length, String(sheet[cell_ref].v).length)
      }
    }
    cols[C] = { wch: max_length + 4 }
  }
  sheet["!cols"] = cols
}
